//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { TextInput } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalMilitaryWaiverNameForm = () => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        // Update Validation State
        if (digital_name && event_name) {
            dispatch(
                updateFormValidity({
                    digital_name: digital_name,
                    errors: {
                        [event_name]: false,
                        [event_name + 'ErrMsg']: '',
                    },
                })
            )
        }
    }

    //////// Functional Methods

    // Handle Data Of All Fields + DatePicker (ID)
    const handleData = (e, id) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        } else if (e?.length > 0 && id) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                    },
                })
            )
            revalidation(id)
        }
        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (
        formsData?.[digital_name]?.values?.HON_DISCHG === 'Y' &&
        formsData?.[digital_name]?.values?.ACTV === 'A'
    ) {
        return (
            <>
                <TextInput
                    className={''}
                    labelText="Name at discharge:"
                    id="VET_NAME"
                    name="VET_NAME"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.VET_NAME}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.VET_NAME}
                    invalidText={
                        formsData?.[digital_name]?.errors?.VET_NAMEErrMsg
                    }
                />
            </>
        )
    } else if (
        formsData?.[digital_name]?.values?.HON_DISCHG === 'Y' &&
        formsData?.[digital_name]?.values?.ACTV === 'S'
    ) {
        return (
            <>
                <TextInput
                    className={''}
                    labelText="Spouse's name at discharge:"
                    id="SPOUSE_NAME"
                    name="SPOUSE_NAME"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.SPOUSE_NAME}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.SPOUSE_NAME}
                    invalidText={
                        formsData?.[digital_name]?.errors?.SPOUSE_NAMEErrMsg
                    }
                />
            </>
        )
    }
}

export default AdditionalMilitaryWaiverNameForm
